import $ from 'jquery';
import debounce from 'lodash/debounce';

window.jQuery = $;
window.$ = $;
window.debounce = debounce;

$('document').ready(() => {});



// WEBPACK FOOTER //
// ./styleguide/src/assets/lib/lib.js